import { ActionTree } from 'vuex';
import { IRootState } from '../root-state.store';
import { IOwnerState } from './owner-state.store';
import { OWNER_GET_OWNERS, OWNER_GET_BLOCK_OWNERS, OWNER_SET_BLOCK_OWNERS, OWNER_LOADING, OWNER_SET_BLOCK_OWNER, OWNER_GET_BLOCK_OWNER } from './owner-types.store';
import { ActivityStatus, UserTypes } from '../../common/enums';

export const actions: ActionTree<IOwnerState, IRootState> = {
  [OWNER_GET_BLOCK_OWNERS]: async ({ state, getters, commit }, payload: { blockId: string, param: any }) => {
    if (state.activityStatus === ActivityStatus.Loading) return;
    commit(OWNER_LOADING, ActivityStatus.Loading)
    return await getters.service.getOwnerByBlockId(payload.blockId, payload.param)
      .then(res => {
        commit(OWNER_SET_BLOCK_OWNERS, res)
        return res;
      })
      .catch(res => {
        console.log(res)
        commit(OWNER_LOADING, ActivityStatus.LoadFailed)
      })
  }
  , [OWNER_GET_BLOCK_OWNER]: async ({ state, commit, rootGetters }, payload: { blockId: string, ownerId: string }) => {

    commit(OWNER_LOADING, ActivityStatus.Loading);
    return state.service.getBlockOwnerById(payload.blockId, payload.ownerId)
      .then(owner => {
        commit(OWNER_SET_BLOCK_OWNER, owner)
        return owner;
      })
      .catch(error => {
        commit(OWNER_LOADING, ActivityStatus.LoadFailed)
        return error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/store/owner/onwer-actions.store.ts